import React, { useEffect } from "react";
import { PeekMultipleSelector } from "@piiqtechnologies/ui-components";
import { useCommunities, useError } from "@piiqtechnologies/ui-lib";
import { USER_ROLES } from "@constants/Roles";
export const MultipleCommunitySelector = ({ onSelect, form, label, placeholder, field, }) => {
    const { setError } = useError();
    const [getCommunities, communities, communitiesLoading, communitiesError] = useCommunities();
    useEffect(() => {
        var _a, _b;
        if ((_a = form.values) === null || _a === void 0 ? void 0 : _a.organizations) {
            getCommunities({
                organization: {
                    _id: ((_b = form.values.organizations) === null || _b === void 0 ? void 0 : _b._id) || form.values.organizations,
                },
            });
        }
    }, [form.values.organizations]);
    useEffect(() => {
        var _a;
        const role = form.values.roleId;
        const isTargetRole = role === USER_ROLES.Scanner || role === USER_ROLES.OrgAdmin;
        const communitiesAvailable = ((_a = communities === null || communities === void 0 ? void 0 : communities.data) === null || _a === void 0 ? void 0 : _a.length) > 0;
        if (isTargetRole && communitiesAvailable) {
            const allCommunityIds = communities.data.map((community) => community._id);
            onSelect(allCommunityIds);
        }
    }, [form.values.roleId, communities === null || communities === void 0 ? void 0 : communities.data]);
    useEffect(() => {
        if (communitiesError)
            setError(communitiesError.message);
    }, [communitiesError]);
    return (React.createElement(PeekMultipleSelector, { form: form, field: field, label: label, placeholder: placeholder, options: (!communitiesLoading && (communities === null || communities === void 0 ? void 0 : communities.data)) || [], selectedOptions: form.values.communities, onSelectionChange: onSelect }));
};
export default MultipleCommunitySelector;
